import axios from 'axios';
import configService from '@/services/configService';
import { unwrapData } from '@/services/apiEnvelope';

export default {
  async list({ authKey } = {}) {
    const headers = {};
    if (authKey) {
      headers.Authorization = authKey;
    }

    return axios
      .get(`${configService.get('apiUrl')}/notification`, { headers })
      .then(response => unwrapData(response.data));
  },

  async patchOne({ id, authKey, type = 'read' } = {}) {
    const headers = {};
    if (authKey) {
      headers.Authorization = authKey;
    }

    return axios
      .patch(`${configService.get('apiUrl')}/notification/${id}?type=${encodeURIComponent(type)}`, { _id: id }, { headers })
      .then(response => unwrapData(response.data));
  }
};
